import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: any) => {
  return {
    box: {
      boxShadow: "1px 1px 25px rgba(11, 55, 101, 0.1)",
      padding: 15,
      borderRadius: 20,
      textAlign: "center",
    },
    titleTerms: {
      font: theme.custom.font.headingMontserrat1,
      fontSize: "15px",
      fontWeight: "bold",
      marginTop: "9px",
    },
    descSupport: {
      font: theme.custom.font.montserrat14,
      color: theme.custom.colors.black,
      marginTop: "14px",
      fontSize: "14px",
    },
    button: {
      backgroundColor: "#000000",
      color: theme.custom.colors.white,
      cursor: "pointer",
      width: 230,
      margin: "auto",
      borderRadius: 20,
      marginTop: "11px",
      marginBottom: "9px",
    },
    label: {
      lineHeight: 2.5,
      font: theme.custom.font.montserrat14,
      fontWeight: "bold",
    },
    header: {
      font: theme.custom.font.headingMontserrat1,
      fontWeight: "bold",
      marginBottom: 30,
    },
    modalContainer: {
      textAlign: "center",
    },
    modalHeader: {
      marginBottom: 80,
      font: theme.custom.font.headingMontserrat1,
      fontSize: "15px",
      fontWeight: "bold",
      marginTop: "13px",
    },
    modalURLHeader: {
      marginBottom: 20,
      font: theme.custom.font.headingMontserrat1,
      fontSize: "15px",
      fontWeight: "bold",
      marginTop: "13px",
    },
    option: {
      boxShadow: "1px 1px 25px rgba(11, 55, 101, 0.1)",
      borderRadius: 12,
      padding: 4,
      height: "165px",
      marginBottom: 30,
      cursor: "pointer",
      "&:hover": {
        border: "1px solid #0C85F4",
      },
    },
    boxHeader: {
      font: theme.custom.font.headingMontserrat1,
      fontSize: "15px",
      fontWeight: "bold",
      marginTop: "15px",
    },
    boxDescription: {
      font: theme.custom.font.montserrat14,
      fontSize: "13px",
      textAlign: "left",
      marginTop: "9px",
      width: "66%",
      marginLeft: "auto",
      marginRight: "auto",
      lineHeight: 1.5,
    },

    hasUrlBox: {
      boxShadow: "1px 1px 25px rgba(11, 55, 101, 0.1)",
      padding: "15px 25px 20px 20px",
      borderRadius: 20,
    },

    hasUrlHeader: {
      font: theme.custom.font.montserrat14,
      fontSize: "15px",
      marginTop: "9px",
    },

    tncColor: {
      font: theme.custom.font.montserrat14,
      marginTop: "14px",
      fontSize: "13px",
      color: "#0C85F4",
      fontWeight: "bold",
    },

    editTnc: {
      font: theme.custom.font.montserrat14,
      marginTop: "14px",
      fontSize: "13px",
      color: "#0C85F4",
      fontWeight: "bold",
      textAlign: "right",
      cursor: "pointer",
    },
    replaceTncWithText: {
      font: theme.custom.font.montserrat14,
      marginTop: "14px",
      fontSize: "13px",
      color: "#0C85F4",
      fontWeight: "bold",
      textAlign: "right",
      cursor: "pointer",
    },

    buttonContainer: {
      height:  50,
      marginRight: 20,

    },
    buttonLabel: {
      font: theme.custom.font.montserrat14,
      fontWeight: "bold",
      cursor: "pointer",
      marginTop: 1,
    },
    ActionButton: {
      font: theme.custom.font.montserrat14,
      borderRadius: 30,
      lineHeight: 1.5,
      paddingLeft: 16,
      paddingRight: 16,
      paddingTop: 8
    },
    errorText: {
      color: "red",
      font: theme.custom.font.montserrat14,
    },
    closeIcon: {
      display: "flex",
      justifyContent: "flex-end",
      cursor: "pointer",
      marginTop: -40,
    },
    closingIcon: {
      display: "flex",
      justifyContent: "flex-end",
      cursor: "pointer",
      marginTop: -100,
      position: "absolute",
      right: 25,
    },
    dialogCustom: {
      "& button.Mui-focusVisible>span:last-child": {
        display: "none",
      },
      "& h3": {
        fontSize: "18px",
      },
      "& .MuiDialog-paperWidthSm": {
        width: "561px",
        height: "160px",
      },
    },
    titleDialog: {
      font: theme.custom.font.montserrat14,
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "12px",
    },
    iconClose: {
      cursor: "pointer",
    },
    contentDialog: {
      font: theme.custom.font.montserrat14,
      fontSize: "15px",
      lineHeight: "24px",
    },
    buttonBox: {
      padding: "10px 20px",
    },
    buttonDelete: {
      font: theme.custom.font.montserrat14,
      background: theme.custom.colors.primary,
      color: theme.custom.colors.white,
      textTransform: "unset",
      padding: "8px 16px",
      borderRadius: "100px",
      "&:hover": {
        background: theme.custom.colors.primary,
      },
    },
    buttonCancel: {
      font: theme.custom.font.montserrat14,
      background: theme.custom.colors.primary,
      color: theme.custom.colors.white,
      textTransform: "unset",
      padding: "8px 16px",
      borderRadius: "100px",
      "&:hover": {
        background: theme.custom.colors.primary,
      },
    },
  };
});

export default useStyles;
